import inputConfig, { AlmeInputConfig } from "../AlmeInput/AlmeInputConfig";
import poweredByConfig, { AlmePoweredByLinkConfig } from "../AlmePoweredByLink/AlmePoweredByLInkConfig";
import disclaimerConfig, { AlmeDisclaimerConfig } from "../AlmeDisclaimer/AlmeDisclaimerConfig";

interface FooterConfig extends AlmeInputConfig, AlmePoweredByLinkConfig, AlmeDisclaimerConfig {
    styles: {
        hasBorder: boolean;
        hasBackgroundColor: boolean;
    };
}

export interface AlmeFooterConfig {
    footer: FooterConfig;
}

/**
 * This is the baseline footer config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeFooterConfig = {
    footer: {
        ...inputConfig,
        ...poweredByConfig,
        ...disclaimerConfig,
        styles: {
            hasBackgroundColor: false,
            hasBorder: false,
        },
    },
};

export default defaultConfig;
